import React, { useState, useEffect } from 'react';
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import appointmentService from "../../../Services/appointmentService";

const Appointment = () => {
  const [Appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        setLoading(true);
        const data = await appointmentService.fetchAllAppointments();
        if (data.responseCode === 200) {
          setAppointments(data.appointments);
        } else {
          setError("Failed to fetch Appointments");
        }
      } catch (err) {
        setError("Server error. Please check if backend is running.");
      } finally {
        setLoading(false);
      }
    };
    fetchAppointments();
  }, []);

  const handleView = async (id) => {
    try {
      const data = await appointmentService.fetchAppointmentById(id);
      if (data.responseCode === 200) {
        setSelectedAppointment(data.appointment);
        setIsModalOpen(true);
      }
    } catch (err) {
      console.error("Error fetching Appointment:", err);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedAppointment(null);
  };

  const filtered = Appointments.filter((a) =>
    a.full_name.toLowerCase().includes(search.toLowerCase()) ||
    a.contact_number.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-3 sm:p-6">

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-5 shadow-sm">
        <div>
          <h1 className="text-[16px] sm:text-[17px] font-[500] text-gray-800">
            Appointment Table
          </h1>
          <p className="text-[12px] text-gray-400 mt-0.5">
            {Appointments.length} records found
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
          <div className="relative">
            <SearchIcon
              className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
              style={{ fontSize: 16 }}
            />
            <input
              type="search"
              placeholder="Search by name or phone..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-8 pr-3 py-[7px] w-full sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg"
            />
          </div>

          <Link to="AddAppointment" className="w-full sm:w-auto">
            <button className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#255A8C] text-white text-[13px] px-4 py-[7px] rounded-lg">
              + New Appointment
            </button>
          </Link>
        </div>
      </div>


      <div className='hidden md:block border border-gray-200 bg-white rounded-xl overflow-hidden shadow-sm'>
        <div className="overflow-x-auto">
          <table className='w-full min-w-[700px]'>
            <thead>
              <tr className="bg-[#215187] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">#</th>
                <th className="py-3 px-4 text-left">Patient</th>
                <th className="py-3 px-4 text-left">Phone</th>
                <th className="py-3 px-4 text-left">Doctor</th>
                <th className="py-3 px-4 text-center">Date</th>
                <th className="py-3 px-4 text-center">Time</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={7} className="py-8 text-center text-[13px] text-gray-400">Loading...</td></tr>
              ) : error ? (
                <tr><td colSpan={7} className="py-8 text-center text-[13px] text-red-400">{error}</td></tr>
              ) : filtered.length === 0 ? (
                <tr><td colSpan={7} className="py-8 text-center text-[13px] text-gray-400">No Appointments found.</td></tr>
              ) : (
                filtered.map((Appointment, index) => (
                  <tr key={Appointment.id} className="border-t hover:bg-gray-50 text-[13px] transition-colors">
                    <td className='py-3 px-4 border-b text-left'>{index + 1}</td>
                    <td className='py-3 px-4 border-b text-left font-[500]'>{Appointment.full_name}</td>
                    <td className='py-3 px-4 border-b text-left'>{Appointment.contact_number}</td>
                    <td className='py-3 px-4 border-b text-left'>{Appointment.doctor_assigned}</td>
                    <td className='py-3 px-4 border-b text-center'>{Appointment.checkup_date}</td>
                    <td className='py-3 px-4 border-b text-center'>{Appointment.checkup_time}</td>
                    <td className='py-3 px-4 border-b text-center'>
                      <button
                        onClick={() => handleView(Appointment.id)}
                        className="inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-[#215187]/10 transition-colors group"
                        title="View Appointment details"
                      >
                        <MdOutlineRemoveRedEye className="text-[18px] text-gray-400 group-hover:text-[#215187] transition-colors" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>


      <div className='md:hidden flex flex-col gap-3'>
        {loading ? (
          <div className="py-10 text-center text-[13px] text-gray-400">Loading...</div>
        ) : error ? (
          <div className="py-10 text-center text-[13px] text-red-400">{error}</div>
        ) : filtered.length === 0 ? (
          <div className="py-10 text-center text-[13px] text-gray-400">No Appointments found.</div>
        ) : (
          filtered.map((Appointment, index) => (
            <div
              key={Appointment.id}
              className="bg-white border border-gray-200 rounded-xl px-4 py-4 shadow-sm"
            >
              <div className="flex items-center justify-between gap-2 mb-3">
                <div className="flex items-center gap-2 min-w-0 flex-1">
                  <span className="text-[11px] font-[600] text-[#215187] bg-[#215187]/10 px-2 py-0.5 rounded-full flex-shrink-0">
                    #{index + 1}
                  </span>
                  <span className="text-[14px] font-[500] text-gray-800 truncate">{Appointment.full_name}</span>
                </div>
                <button
                  onClick={() => handleView(Appointment.id)}
                  className="flex items-center gap-1.5 text-[12px] text-[#2F6DB4] font-[500] hover:text-[#215187] transition-colors flex-shrink-0 whitespace-nowrap bg-[#2F6DB4]/10 hover:bg-[#215187]/10 px-2.5 py-1.5 rounded-lg border border-[#2F6DB4]/20"
                  title="View Appointment details"
                >
                  <MdOutlineRemoveRedEye className="text-[15px] flex-shrink-0" />
                  <span>View</span>
                </button>
              </div>

              <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 text-[12px]">
                <div>
                  <p className="text-gray-400 mb-0.5">Phone</p>
                  <p className="text-gray-700 font-[500]">{Appointment.contact_number || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">Doctor</p>
                  <p className="text-gray-700 font-[500]">{Appointment.doctor_assigned || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">Date</p>
                  <p className="text-gray-700 font-[500]">{Appointment.checkup_date || "—"}</p>
                </div>
                <div>
                  <p className="text-gray-400 mb-0.5">Time</p>
                  <p className="text-gray-700 font-[500]">{Appointment.checkup_time || "—"}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {isModalOpen && selectedAppointment && (
        <div
          className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
          onClick={closeModal}
        >
          <div
            className="bg-white rounded-xl shadow-lg w-full max-w-md p-5 relative"
            onClick={(e) => e.stopPropagation()}
          >
           <div className="flex bg-[#215187] px-5 py-4 items-center justify-between rounded-t-xl -mx-5 -mt-5 mb-4">
            <h2 className="text-[14px] font-[500] text-white uppercase tracking-wide">
              Appointment Details
            </h2>
            <button
              onClick={closeModal}
              className="text-white hover:bg-white/20 rounded-lg p-1 transition-colors"
            >
              <IoClose className="text-[20px]" />
            </button>
          </div>

            <div className="flex flex-col gap-3 text-[13px]">
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-400">Patient</span>
                <span className="text-gray-800 font-[500]">{selectedAppointment.full_name}</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-400">Phone</span>
                <span className="text-gray-800 font-[500]">{selectedAppointment.contact_number}</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-400">Doctor</span>
                <span className="text-gray-800 font-[500]">{selectedAppointment.doctor_assigned}</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-400">Date</span>
                <span className="text-gray-800 font-[500]">{selectedAppointment.checkup_date}</span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-400">Time</span>
                <span className="text-gray-800 font-[500]">{selectedAppointment.checkup_time}</span>
              </div>
              {selectedAppointment.notes && (
                <div className="flex flex-col gap-1">
                  <span className="text-gray-400">Notes</span>
                  <span className="text-gray-800 font-[500]">{selectedAppointment.notes}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Appointment;